import { render, staticRenderFns } from "./SellingTenders.vue?vue&type=template&id=31a272cf&"
import script from "./SellingTenders.vue?vue&type=script&lang=ts&"
export * from "./SellingTenders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports